import { Box } from "@mui/material";
import { gridClasses } from "@mui/x-data-grid-premium";
import { useCallback, useState } from "react";
import { createPortal } from "react-dom";
import InlineLoader from "@entrilia/shared/components/inlineLoader/InlineLoader.tsx";

const loaderSx = {
  top: "var(--DataGrid-topContainerHeight)",
  bottom: "var(--DataGrid-bottomContainerHeight)",
  left: 0,
  right: 0,
  width: "auto",
  height: "auto",
  zIndex: 100,
};
const anchorSx = { display: "none" };

const ReportLoadingOverlay = () => {
  const [rootElement, setRootElement] = useState<HTMLElement | null>(null);
  const handleAnchorRef = useCallback((anchor: HTMLDivElement | null) => {
    const gridSelector = `.${gridClasses.root}`;
    // Slots sit inside the horizontal scroller; refresh indicators are siblings of the grid.
    setRootElement(
      anchor?.closest<HTMLElement>(gridSelector) ??
        anchor?.parentElement?.querySelector<HTMLElement>(gridSelector) ??
        null
    );
  }, []);

  return (
    <Box ref={handleAnchorRef} sx={anchorSx}>
      {rootElement && createPortal(<InlineLoader overlay sx={loaderSx} />, rootElement)}
    </Box>
  );
};

export default ReportLoadingOverlay;
